import { createFileRoute } from "@tanstack/react-router";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import { SHARE_IMAGES } from "@/lib/share-images";

const FAQ = [
  { q: "How long does the glow last?", a: "Brightest in the first few minutes after a full charge, then a gradual fade. Recharge between holes for consistent visibility." },
  { q: "Are these legal for tournament play?", a: "No. Glow Long is a recreational product — not officially tournament approved. We don't make distance or performance claims." },
  { q: "How do I charge them?", a: "30–60 seconds under a bright light source — sunlight, phone flashlight, or any bright lamp. Brighter source means brighter glow." },
  { q: "Do they need batteries?", a: "No batteries. They're phosphorescent (charge under light), not LED." },
  { q: "Are they the same size as a normal golf ball?", a: "Yes. Standard 42.67 mm diameter, 2-piece construction. Plays like a normal ball." },
  { q: "How many colors come in a pack?", a: "Six colors per pack — one each of red, green, pink, white, blue, and orange." },
  { q: "Where do orders ship from?", a: "Orders ship from Amazon's fulfillment network for fast, reliable delivery." },
  { q: "Can I return them?", a: "Yes — unused packs within 30 days of delivery. See our Shipping & returns page." },
  { q: "Do you do custom packaging for events?", a: "Yes, for larger orders. Tell us about your event on the Events page." },
];

export const Route = createFileRoute("/faq")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("faq")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "FAQ — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "Glow duration, charging, tournament rules, returns, shipping, and custom event packs — answers about Glow Long glow-in-the-dark golf balls." },
      { property: "og:title", content: loaderData?.title || "Glow Long Golf — FAQ" },
      { property: "og:description", content: loaderData?.meta_description || "Answers about glow duration, charging, sizing, returns, and event orders." },
      { property: "og:url", content: "https://glowlonggolf.com/faq" },
      { property: "og:image", content: SHARE_IMAGES.macroDew },
      { name: "twitter:image", content: SHARE_IMAGES.macroDew },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/faq" }],

    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }),
    }],
  }),
  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: () => (
    <EditablePageShell slug="faq" defaults={{ eyebrow: "FAQ", title: "Common questions" }}>
      <section className="mx-auto max-w-3xl px-4 pb-16 sm:px-6 lg:px-8">
        <dl className="divide-y divide-border rounded-2xl border border-border bg-card">
          {FAQ.map((f) => (
            <div key={f.q} className="p-5">
              <dt className="font-medium">{f.q}</dt>
              <dd className="mt-2 text-sm text-muted-foreground">{f.a}</dd>
            </div>
          ))}
        </dl>
      </section>
    </EditablePageShell>
  ),
});
